export const ROOT_FOLDER = {
  id: 0,
} as const

export const RECENT_FOLDER = {
  id: 'recentFolder',
} as const
